module.exports = __webpack_public_path__ + "img/DE05205.c06575d7.png";